import { createTheme } from "@mui/material";
import MatterWoff2 from '../fonts/Matter-Regular.woff2';
import MatterMediumWoff2 from '../fonts/Matter-Medium.woff2';
import MatterSemiBoldWoff2 from '../fonts/Matter-SemiBold.woff2';
import MatterBoldWoff2 from '../fonts/Matter-Bold.woff2';
import type {} from '@mui/x-data-grid/themeAugmentation';

declare module '@mui/material/styles' {
  interface Theme {
    pandia: {
      blue: string;
      blue_600: string;
      indigo: string;
      indigo_dark: string;
      indigo_light: string;
      darker_green: string;
    }
  }

  interface ThemeOptions {
    pandia?: {
      blue?: string;
      blue_600?: string;
      indigo?: string;
      indigo_dark?: string;
      indigo_light?: string;
      darker_green?: string;
    };
  }
  interface BreakpointOverrides {
    xs: false; 
    sm: false;
    md: false;
    lg: false;
    xl: false;
    tablet: true;
    tablet_wide: true;
    mobile: true;
    desktop: true;
    desktop_wide: true;
  }
}


const theme = createTheme({
  typography: {
    fontFamily: 'Matter',
  },
  palette: {
    primary: {
      main: '#3455CD',     
    },
    error: {
      main: '#D32F2F',
    },
    info: {
      main: '#3455CD',
    },
  },
  pandia: {
    blue: '#EBEEFA',
    blue_600: '#2F4DBB',
    indigo: '#222D6E',
    indigo_dark: '#222D6E',
    indigo_light: '#4E578B',
    darker_green: '#537264'
  },
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 440,
      tablet_wide: 580,
      desktop: 840,
      desktop_wide: 1160,
    },
  },
  mixins: {
    MuiDataGrid: {
      // Headers, and top & bottom fixed rows
      containerBackground: '#E8E9EA',
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'normal',
          textTransform: 'none'
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Matter';
            src: url('${MatterWoff2}') format('woff2');
            font-weight: 400;
          }
        @font-face {
          font-family: 'Matter';
          src: url('${MatterMediumWoff2}') format('woff2');
          font-weight: 500;
        }
        @font-face {
          font-family: 'Matter';
          src: url('${MatterSemiBoldWoff2}') format('woff2');
          font-weight: 600;
        }
        @font-face {
          font-family: 'Matter';
          src: url('${MatterBoldWoff2}') format('woff2');
          font-weight: 700;
        }
      `,
    }
  },
});

export default theme;
